"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusListView = void 0;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _Localization = require("../Localization");
var _translations = require("../entities/translations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StatusListView = _ref => {
  let {
    radioGroupRef,
    value,
    handleChange,
    handleSet,
    options
  } = _ref;
  const tV = (0, _Localization.useTranslationValue)();
  const {
    OK
  } = (0, _reactRedux.useSelector)(_translations.selectActiveTranslationsInterfaceUILocalizations);
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, options !== null && options !== void 0 && options.length ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      maxHeight: '50vh',
      overflowY: 'scroll',
      paddingBottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_material.RadioGroup, {
    ref: radioGroupRef,
    name: "statuses",
    value: value,
    onChange: handleChange,
    color: "text.primary"
  }, options.map(option => /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    value: option.id,
    key: option.id,
    control: /*#__PURE__*/_react.default.createElement(_material.Radio, {
      sx: {
        color: 'text.primary'
      }
    }),
    label: tV(option.value)
  })))), /*#__PURE__*/_react.default.createElement(_material.Divider, null), /*#__PURE__*/_react.default.createElement(_material.DialogActions, {
    sx: {
      padding: 0,
      paddingTop: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    color: "primary",
    variant: "contained",
    onClick: handleSet,
    disableElevation: true
  }, OK))) : /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "subtitle2"
  }, "List is empty"));
};
exports.StatusListView = StatusListView;
StatusListView.propTypes = {
  radioGroupRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  }).isRequired]),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  handleChange: _propTypes.default.func.isRequired,
  handleSet: _propTypes.default.func.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    value: _propTypes.default.shape({
      [_propTypes.default.oneOf([''])]: _propTypes.default.string
    })
  })).isRequired
};